export const ISAUTHENTICATED = "ISAUTHENTICATED";
export const LOGIN_LOADING_START = "LOGIN_LOADING_START";
export const LOGIN_LOADING_DONE = "LOGIN_LOADING_DONE";

export const UPDATE_CLIENT_BALANCE = "UPDATE_CLIENT_BALANCE";
export const UPDATE_CLIENT_BALANCE_FT = "UPDATE_CLIENT_BALANCE_FT";

export const PROFILE_DETAILS = "PROFILE_DETAILS";

export const LOADING_START = "LOADING_START";
export const LOADING_END = "LOADING_END";

//send gift

export const ADD_ACCOUNTS = "ADD_ACCOUNTS";
export const REMOVE_ACCOUNTS = "REMOVE_ACCOUNTS";
export const REMOVE_ACCOUNT = "REMOVE_ACCOUNT";

export const CURRENT_TRANSACTION_TAB = "CURRENT_TRANSACTION_TAB";

export const SCHEDULE_JOB = "SCHEDULE_JOB";
export const REMOVE_JOB = "REMOVE_JOB";

export const SET_INTERVAL_ID = "SET_INTERVAL_ID";
export const CLEAR_INTERVAL_ID = "CLEAR_INTERVAL_ID";
